
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftRight50 as ObiThreewayAcuatorGenericInleftRight50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-right-50.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftRight50 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-right-50',
   elementClass: ObiThreewayAcuatorGenericInleftRight50Element,
   events: {
     
   }
  });
 
 